import { useState, useEffect } from 'react';

/**
 * Custom hook to detect and track dark mode state
 * Listens for theme-reload events and checks data-bs-theme attribute
 * @returns {boolean} isDarkMode - Current dark mode state
 */
const useDarkMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(
    document.documentElement.getAttribute('data-bs-theme') === 'dark'
  );

  useEffect(() => {
    const handleThemeChange = () => {
      const darkMode = document.documentElement.getAttribute('data-bs-theme') === 'dark';
      setIsDarkMode(darkMode);
    };

    // Listen for theme-reload event
    document.addEventListener('theme-reload', handleThemeChange);
    
    // Also check on mount
    handleThemeChange();

    return () => {
      document.removeEventListener('theme-reload', handleThemeChange);
    };
  }, []);

  return isDarkMode;
};

export default useDarkMode;

